<div [ngStyle]="skeletonStyles" [class]="skeletonClasses"></div>
